module.exports = __webpack_public_path__ + "img/four_icon.4c21fa56.png";